import { Role } from "../utils/types/role.type";
import { ApiClient, ClientType } from './apiClient/ApiClient';
import { ServiceType } from './apiClient/config';

const apiClient = () => { return ApiClient.Client(ClientType.NotCached, ServiceType.Api); };

export const getRoles = async () => await apiClient().get<Role[]>('administrators/roles');
